import React from "react";
import ReactDOM from "react-dom";
import "./scss/index.scss";
import 'semantic-ui-css/semantic.min.css';
import App from "./App";

const rootEl = document.getElementById("react-app");
if (rootEl) {
  const settings = JSON.parse(rootEl.getAttribute('data-default-settings'));
  ReactDOM.render(
    <React.StrictMode>
      <App settings={settings} />
    </React.StrictMode>,
    rootEl
  );
}